// Board of Directors Data
export const boardData = {
  title: "Board of Directors",
  subtitle: "Meet the dedicated leaders guiding our mission to support early childhood education in Washington, DC.",
  description: "Our 15-member board brings together diverse expertise from across the early childhood education sector, united in their commitment to building a thriving future for every child.",
  
  members: [
    // Board Officers
    {
      id: 1,
      name: "Carrie Thornhill",
      title: "Board President",
      affiliation: "DC Early Learning Collaborative",
      image: "https://customer-assets.emergentagent.com/job_early-learning-hub-2/artifacts/9nib4xo6_Carrie%20Thornhill.JPG",
      bio: "Carrie Thornhill serves as Board President of the DC Early Learning Collaborative, bringing a steadfast commitment to equitable early childhood education across Washington, DC. With a career rooted in advocacy and community leadership, she guides the organization\u2019s strategic direction and ensures that every child in the District has access to quality early learning opportunities.",
      isOfficer: true
    },
    {
      id: 2,
      name: "William Sherman",
      title: "Vice President",
      affiliation: "Dinsmore",
      image: "https://customer-assets.emergentagent.com/job_early-learning-hub-2/artifacts/7jefym24_William%20Sherman.JPG",
      bio: "William Sherman brings seasoned leadership and strategic insight to his role as Vice President of the DCELC Board of Directors. Drawing on his professional background at Dinsmore, he works closely with board leadership to advance the organization\u2019s mission and strengthen governance, partnerships, and long-term planning for early childhood education in DC.",
      isOfficer: true
    },
    {
      id: 3,
      name: "Jeffrey Credit",
      title: "Treasurer",
      affiliation: "Community Education Research Group",
      image: "https://customer-assets.emergentagent.com/job_early-learning-hub-2/artifacts/sl1iplwh_Jeffrey%20Credit.JPG",
      bio: "Jeffrey Credit serves as Treasurer of the DCELC Board, overseeing the organization\u2019s financial stewardship and ensuring responsible management of its resources. Affiliated with the Community Education Research Group, he brings a data-informed perspective to fiscal oversight, helping DCELC remain accountable and sustainable in its work supporting early learners across the District.",
      isOfficer: true
    },
    {
      id: 4,
      name: "Julie Dobies",
      title: "Secretary",
      affiliation: "Kaplan Early Learning Company",
      image: "https://customer-assets.emergentagent.com/job_19451de5-ade2-4c9c-97e0-a11403f5250c/artifacts/zu449u9m_Julie%20Dobies.JPG",
      bio: "Julie Dobies serves as Secretary of the DCELC Board, managing board records and communications to support strong organizational governance. With her background at Kaplan Early Learning Company, she brings expertise in early childhood education systems and a dedication to operational excellence that keeps the board well-coordinated and mission-focused.",
      isOfficer: true
    },

    // Board Members (Alphabetical)
    {
      id: 5,
      name: "Berna Artis",
      title: "Board Member",
      affiliation: "DC Association for the Education of Young Children (DCAEYC)",
      image: "https://customer-assets.emergentagent.com/job_early-learning-hub-2/artifacts/uvjbljck_Berna%20Artis.jpg",
      bio: "Berna Artis is a dedicated board member who brings the spirit and expertise of the DC Association for the Education of Young Children to her work with DCELC. Committed to building a thriving future for every child, she supports collaborative leadership and champions high-quality, inclusive early learning environments across Washington, DC."
    },
    {
      id: 6,
      name: "Jamal Berry",
      title: "Board Member",
      affiliation: "EduCare DC",
      image: "https://customer-assets.emergentagent.com/job_19451de5-ade2-4c9c-97e0-a11403f5250c/artifacts/ng7ifv6b_Jamal%20Berry-Board%20Pic.JPG",
      bio: "Jamal Berry is a passionate advocate for early childhood education, committed to ensuring every child in DC has equitable access to quality learning experiences. Through his work with EduCare DC, he has developed deep expertise in early education programming and community engagement, and he brings that energy and drive to his service on the DCELC Board."
    },
    {
      id: 7,
      name: "Cynthia Davis",
      title: "Board Member",
      affiliation: "DC Family Child Care Association",
      image: "https://customer-assets.emergentagent.com/job_early-learning-hub-2/artifacts/s6eg4n57_Cynthia%20Davis.jpg",
      bio: "Cynthia Davis represents the DC Family Child Care Association on the DCELC Board, where she works to strengthen community partnerships and support the early childhood education workforce. A dedicated advocate for family child care providers, she brings firsthand knowledge of the challenges and opportunities facing educators and families across the District."
    },
    {
      id: 8,
      name: "Dr. Marla Dean",
      title: "Board Member",
      affiliation: "The Community Foundation",
      image: "https://customer-assets.emergentagent.com/job_19451de5-ade2-4c9c-97e0-a11403f5250c/artifacts/c2gxmd0s_Dr.%20Marla%20Dean%20.JPG",
      bio: "Dr. Marla Dean is a dedicated advocate for early childhood education, drawing on extensive experience in educational leadership and community development to inform her board service. Through her affiliation with The Community Foundation, she brings a philanthropic lens to DCELC\u2019s mission, helping to build the partnerships and resources needed for lasting impact."
    },
    {
      id: 9,
      name: "Cristina Encinas",
      title: "Board Member",
      affiliation: "Multicultural Spanish Speaking Providers Association",
      image: "https://customer-assets.emergentagent.com/job_early-learning-hub-2/artifacts/qv5576nx_Cristina%20Encinas.JPG",
      bio: "Cristina Encinas brings a vital multicultural perspective to the DCELC Board through her work with the Multicultural Spanish Speaking Providers Association. She is committed to advancing quality early learning programs and ensuring that diverse communities across the DC area \u2014 including Spanish-speaking families \u2014 have full access to the supports and services they need."
    },
    {
      id: 10,
      name: "Dr. Marilyn Hamilton",
      title: "Board Member",
      affiliation: "University of the District of Columbia",
      image: "https://customer-assets.emergentagent.com/job_early-learning-hub-2/artifacts/vjlaq6qe_Dr.%20Marilyn%20Hamilton.jpg",
      bio: "Dr. Marilyn Hamilton brings the rigor of academia to DCELC\u2019s work, contributing research-driven insights and scholarly expertise as a faculty member at the University of the District of Columbia. Her deep knowledge of early childhood development and educational policy strengthens the board\u2019s capacity to advance evidence-based initiatives that improve outcomes for DC\u2019s youngest learners."
    },
    {
      id: 11,
      name: "Dr. Beverly Jackson",
      title: "Board Member",
      affiliation: "Former Head Start Staffer / Early Childhood Education Expert",
      image: "https://customer-assets.emergentagent.com/job_early-learning-hub-2/artifacts/fvtafe9j_Dr.%20Beverly%20Jackson.JPG",
      bio: "Dr. Beverly Jackson is an experienced educator and researcher whose career has been dedicated to improving outcomes for children in their earliest years. With a background rooted in Head Start and decades of expertise in early childhood education, she brings a wealth of practical knowledge and unwavering commitment to the DCELC Board\u2019s efforts to serve DC\u2019s young children."
    },
    {
      id: 12,
      name: "Sia Barbara Kamara",
      title: "Board Member",
      affiliation: "Early Childhood Education Expert",
      image: "https://customer-assets.emergentagent.com/job_early-learning-hub-2/artifacts/0cmqsjnd_Sia%20Barbara%20Kamara.JPG",
      bio: "Sia Barbara Kamara is passionate about creating equitable opportunities for young children and families across Washington, DC. As an early childhood education expert, she brings both professional depth and personal conviction to her board service, advocating for systems and programs that ensure every child \u2014 regardless of background \u2014 can thrive during their most formative years."
    },
    {
      id: 13,
      name: "Cassandra Nelson",
      title: "Board Member",
      affiliation: "CEO, KU Kids",
      image: "https://customer-assets.emergentagent.com/job_early-learning-hub-2/artifacts/wofy4kks_Cassandra%20Nelson.JPG",
      bio: "Cassandra Nelson is the CEO of KU Kids and a respected leader in early childhood development and community engagement. She brings executive experience and operational expertise to the DCELC Board, with a deep commitment to expanding access to quality early education and building strong partnerships that support children, families, and providers across the DC community."
    },

    // Vacant Positions
    {
      id: 14,
      name: "Vacant Position",
      title: "Board Member",
      affiliation: null,
      image: null,
      bio: "This board seat is currently open. Interested in serving? Contact us to learn more about board opportunities.",
      isVacant: true
    },
    {
      id: 15,
      name: "Vacant Position",
      title: "Board Member",
      affiliation: null,
      image: null,
      bio: "This board seat is currently open. Interested in serving? Contact us to learn more about board opportunities.",
      isVacant: true
    }
  ]
};
